export const D = {
  bg:           'var(--cv-bg-base)',
  bgGrad:       'radial-gradient(120% 80% at 30% 0%, #FBF7ED 0%, #F3EEE3 60%, #EAE3D2 100%)',
  card:         'var(--cv-bg-surface)',
  cardBorder:   'var(--cv-border)',
  accent:       'var(--cv-amber)',
  accentText:   'var(--cv-teal)',
  accentHover:  'var(--cv-amber-hover)',
  accentSoft:   'var(--cv-amber-soft)',
  teal:         'var(--cv-teal)',
  tealSoft:     'var(--cv-teal-soft)',
  green:        '#059669',
  greenSoft:    'rgba(5,150,105,0.12)',
  amber:        'var(--cv-amber)',
  amberSoft:    'var(--cv-amber-soft)',
  text:         'var(--cv-text)',
  textMuted:    'var(--cv-text-muted)',
  textDim:      'var(--cv-text-dim)',
  border:       'var(--cv-border)',
  borderWarm:   'var(--cv-border-warm)',
  borderTeal:   'var(--cv-border-teal)',
  shadow:       'var(--cv-shadow-sm)',
  shadowAmber:  'var(--cv-shadow-amber)',
  shadowIsland: 'var(--cv-shadow-island)',
  mono:         "ui-monospace, 'SF Mono', Menlo, monospace",
  fontDisplay:  'var(--cv-font-display)',
};

export const ER = {
  bgGrad:   '#F5F0E6',
  card:     '#152B1E',
  text:     '#F0EDE8',
  textMuted:'rgba(240,237,232,0.55)',
  textDim:  'rgba(240,237,232,0.28)',
  border:   'rgba(255,255,255,0.08)',
};
